import { connect } from 'react-redux'
import TripFeedbackPane from '../../components/trip-feedbacks/TripFeedbackPane'
import { actionCreators } from '../../state/actions/trips'
import { IStoreState, ITripFilters } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    routeProps: ownProps,
    orgId: state.organizations.currentOrgId
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateTripFilters: (params: ITripFilters) => dispatch(actionCreators.updateTripFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripFeedbackPane)



// WEBPACK FOOTER //
// ./src/containers/trip-feedbacks/TripFeedbackPane.ts